import { render, staticRenderFns } from "./limitDiscount.vue?vue&type=template&id=455d80b4&"
import script from "./limitDiscount.vue?vue&type=script&lang=ts&"
export * from "./limitDiscount.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports